import { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './excellentStore.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { ExcellentStore } from 'model/dealerStore/excellentStore.model';

export interface ExcellentStoreDetailsProps extends DetailsStateAndDispatchProps<ExcellentStore,'storeLable'>,
  RouteComponentProps, StateProps, DispatchProps {
}
const ExcellentStoreDetails: FC<ExcellentStoreDetailsProps> = (props) => {
  return (
    <DetailsPage<ExcellentStore,'storeLable'>
      title={'优秀实体店详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<ExcellentStore>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ excellentStore }: RootState) => ({
  entity: excellentStore.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ExcellentStoreDetails);
